var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "table",
        {
          staticClass: "col-md-12",
          attrs: { cellspacing: "0", cellpadding: "0" }
        },
        [
          _vm._m(0),
          _c(
            "tbody",
            [
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.arrayPendencias.length == 0,
                      expression: "arrayPendencias.length == 0"
                    }
                  ]
                },
                [
                  _c(
                    "td",
                    { staticClass: "text-center", attrs: { colspan: "50" } },
                    [_vm._v(_vm._s(_vm.msgNenhumRegistroEncontrado()))]
                  )
                ]
              ),
              _vm._l(_vm.arrayPendencias, function(obs) {
                return _c("tr", { key: obs.codObservacao }, [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.numSequencia) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.txtPendencia) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.desSetorPendencia) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.datPendenciaFormatadoSemHora) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(obs.indStatusPendencia) +
                        "\n          "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          obs.indLocalPendencia === "INT" ||
                          obs.indLocalPendencia === "Interna"
                            ? "Interna"
                            : "Externa"
                        ) +
                        "\n          "
                    )
                  ])
                ])
              })
            ],
            2
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left", attrs: { width: "5%" } }, [
          _vm._v("Seq.")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "30%" } }, [
          _vm._v("Pendência")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "30%" } }, [
          _vm._v("Setor")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "10%" } }, [
          _vm._v("Data da pendência")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "5%" } }, [
          _vm._v("Status")
        ]),
        _c("th", { staticClass: "text-left", attrs: { width: "15%" } }, [
          _vm._v("Local da pendência")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }